.pagination {
  display: flex;
  justify-content: center;
  align-items: center;
  padding: var(--space-l);

  .counter {
    margin: 0 var(--space-m);
  }
}
